
    <div class="d-flex flex-column">
        <div class="d-flex flex-grow-1 flex-row menu-rating-item w-100">
          <div *ngIf="image" class="menu-image me-2" [ngStyle]="{ 'background-image': image ? 'url(' + image + ')' : 'url(assets/images/no-image.png)' }">
          </div>
          <div class="d-flex flex-column flex-grow-1 py-1 pe-2 menu-label">
            <label class="flex-grow-1 pointer" (click)="onOpenNotes();">
              {{label}} <span class="text-danger ms-1" *ngIf="config.isRequired">*</span>
            </label>
            <p>{{placeholderNotes}}</p>
          </div>
        </div>
        <div class="d-flex flex-row align-items-center justify-content-between py-2 w-100">
          <div class="flex-grow-1 w-100">
            Rating
          </div>
            <div class="d-flex flex-row pointer">
                <ngx-stars
                    [wholeStars]="true"
                    (click)="$event.stopImmediatePropagation()"
                    [initialStars]="config.initialValue"
                    [customPadding]="'0.9rem'"
                    [customSize]="'1.9rem'"
                    [color]="'#FF9500'"
                    (ratingOutput)="onRatingSet($event)">
                </ngx-stars>
            </div>
        </div>
        <div *ngIf="isOpenNotes && (imagesUploaded  && imagesUploaded.length > 0)" class="d-flex flex-row menu-images my-3">
          <div class="pointer" *ngFor="let path of imagesUploaded; let i = index;" (click)="onClickImage(path)">
            <img [ngSrc]="imageTmpEndpoint + path" class="me-2" fill="contain" [alt]="'menu-image' + i" />
          </div>
        </div>
        <div class="d-flex flex-column w-100">
          <ng-container *ngIf="isOpenNotes">
            <button *ngIf="!imagesUploaded || imagesUploaded.length < 1" mat-flat-button class="d-flex flex-row btn-base btn-upload my-3" type="button" (click)="openUploadDialog('', 'upload')">
              <mat-icon class="pointer"  style="min-width: 24px;">add</mat-icon>
              Tambah Foto
            </button>
          </ng-container>
          <mat-form-field appearance="outline" *ngIf="isOpenNotes">
            <textarea
                #notesEl
                [required]="config.isRequiredOtherValue"
                matInput
                [placeholder]="placeholderNotes"
                rows="2"
                [(ngModel)]="otherValueSet"
                (ngModelChange)="onNotesChange($event)"
                [value]="config.initialOtherValue"
                maxlength="300">
            </textarea>
          </mat-form-field>
            <div *ngIf="!isOpenNotes && (otherValueSet || imagesUploaded.length > 0)" (click)="onOpenNotes()"
                class="d-flex flex-row align-items-center pb-3 text-comment">
              <div class="text-1-line">
                <span *ngIf="otherValueSet">1 Komentar</span>
                <span *ngIf="otherValueSet && imagesUploaded.length > 0">, </span>
                <span *ngIf="imagesUploaded.length > 0">{{ imagesUploaded.length + " foto" }}</span>
              </div>
                <mat-icon class="ms-1 pointer"  style="min-width: 24px;">keyboard_arrow_down</mat-icon>
            </div>
        </div>
    </div>
